// extracted by mini-css-extract-plugin
export var cardTitle = "_ht-1";
export var commentBubble = "_ht-e";
export var commentForm = "_ht-a";
export var commentInput = "_ht-b";
export var commentLabel = "_ht-d";
export var commentPrompt = "_ht-9";
export var csatCard = "_ht-0";
export var feedbackSection = "_ht-7";
export var starDisabled = "_ht-6";
export var starEmpty = "_ht-5";
export var starFilled = "_ht-4";
export var starWrapper = "_ht-3";
export var starsContainer = "_ht-2";
export var submittedComment = "_ht-c";
export var thankYouText = "_ht-8";